import React from 'react';
import StepperList from '../../../../../../../../common/component/StepperList';

const AddonWorkFlow = ({ section }) => (
  <div className="addon-workflow">
    <StepperList section={section} />
  </div>
);

export default AddonWorkFlow;
